import { useState } from "react";

const MeleeBreakdown = ({ meleeData }) => {
  const [open, setOpen] = useState(false);

  if (!meleeData || !meleeData.breakdown?.length) return null;

  return (
    <div className="melee-box mb-3">

      {/* HEADER */}
      <div className="melee-header" onClick={() => setOpen(!open)}>
        <div className="melee-title">
          <span>Melee Breakdown</span>
          {/* <span className="included">INCLUDED</span> */}
        </div>

        <div className={`arrow ${open ? "open" : ""}`}>
          ▾
        </div>
      </div>

      {/* BODY */}
      <div className={`melee-body ${open ? "show" : ""}`}>
        
        <div className="melee-summary">
          <span>TOTAL STONES: <b>{meleeData.total_stones}</b></span>
          <span>TOTAL CARAT: <b>{Number(meleeData.total_carat)}</b></span>
        </div>

        <table className="melee-table">
          <thead>
            <tr>
              <th>CUT</th>
              <th>QUANTITY</th>
              <th>CARAT</th>
              <th>SIZE (MM)</th>
            </tr>
          </thead>
          <tbody>
            {meleeData.breakdown.map((row, i) => (
              <tr key={i}>
                <td>{row.cut}</td>
                <td>x{row.quantity}</td>
                <td className="highlight">
                  {row.carat}
                </td>
                <td>{row.size}</td>
              </tr>
            ))}
          </tbody>
        </table>

      </div>
    </div>
  );
};

export default MeleeBreakdown;